import { Card, Stack, Text } from 'braid-design-system';
import React from 'react';

import { Language, type LanguageProps } from './Language';

interface LanguagesProps {
  languages: LanguageProps[];
  displayVariant?: 'card';
}

export const Languages = (props: LanguagesProps) => {
  const { languages, displayVariant } = props;
  const displayAsCard = displayVariant === 'card';

  return (
    <Stack component="ul" space={displayAsCard ? 'small' : 'medium'}>
      {languages.map((language) =>
        displayAsCard ? (
          <Card key={`language-${language.name.text}`}>
            <Language {...language} />
          </Card>
        ) : (
          <Text key={`language-${language.name.text}`}>
            {language.name.text}
          </Text>
        ),
      )}
    </Stack>
  );
};
